<!-- =========================================================================================
  File Name: ClientEditTabSettings.vue
  Description: Client Edit Tab Settings page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.con-img-upload {
  background: #efeeee;
}
.custom-domain-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-wdt {
  width: 70%;
  margin-right: 15px;
}
.button-wrap {
  text-align: right;
}
.auth-check {
  width: 100%;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}
</style>
<template>
  <div id="client-edit-tab-settings">
    <h3 class="my-5">Plan Details</h3>
    <div class="vx-row mb-6">
      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Max Attendees Per Client</label>
          <vs-input v-model="PlanDetails.MaxAttendeesPerClient" name="MaxAttendeesPerClient" />
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Allow Session On Demand Video</label>
          <vs-switch v-model="PlanDetails.AllowSessionOnDemandVideo" />
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Enhanced Event Branding</label>
          <vs-switch v-model="PlanDetails.EnhancedEventBranding" />
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Allow Session Live Simulated</label>
          <vs-switch v-model="PlanDetails.AllowSessionLiveSimulated" />
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Enable Custom Event Branding</label>
          <vs-switch v-model="PlanDetails.ShowBrandingEventSetup" />
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Allow Session Roundtable</label>
          <vs-switch v-model="PlanDetails.AllowSessionRoundtable" />
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Max Event Days</label>
          <vs-input v-model="PlanDetails.MaxEventDays" />
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Event Access Post Event</label>
          <vs-switch v-model="PlanDetails.EventAccessPostEvent" />
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Enhanced Registration</label>
          <vs-switch v-model="PlanDetails.EnhancedRegistration" />
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Price Per Extra Attendee</label>
          <vs-input v-model="PlanDetails.PricePerExtraAttendee" />
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Contract Start Date</label>
          <flat-pickr
            :config="configdateTimePickerStart"
            class="time-pkr"
            placeholder="Start Date"
            v-validate="'required'"
            name="ContractStartDate"
            v-model="PlanDetails.ContractStartDate"
          ></flat-pickr>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Contract End Date</label>
          <flat-pickr
            :config="configdateTimePickerEnd"
            class="time-pkr"
            placeholder="End Date"
            v-validate="'required'"
            name="ContractEndDate"
            v-model="PlanDetails.ContractEndDate"
          ></flat-pickr>
        </div>
      </div>

      <div class="vx-col md:w-1-12 w-full mt-5 button-wrap">
        <vs-button class="mb-2" @click="save_changes">Save</vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

var vm;
export default {
  components: {
    flatPickr,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      PlanDetails: JSON.parse(JSON.stringify(this.data)),
      favicon: null,
      configdateTimePickerStart: {
        minDate: new Date(),
        onChange: function (val) {
          if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "Y/m/d H:i",
      },
      configdateTimePickerEnd: {
        minDate: new Date(),
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "Y/m/d H:i",
      },
    };
  },

  methods: {
    save_changes() {
      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      this.$vs.loading();
      /* eslint-enable */
      const Id = this.$route.params.clientId;
      if (Id) {
        this.$store
          .dispatch("clientManagement/updateClientPlanDetails", {
            id: Id,
            PlanDetails: this.PlanDetails,
          })
          .then((res) => {
            this.$vs.notify({
              color: "success",
              title: "Client",
              text: res.message,
            });
            this.$vs.loading.close();
          })
          .catch((err) => {
            this.$vs.loading.close();
            console.error(err);
          });
      }
    },
  },
  mounted() {
    vm = this;
  },
};
</script>